import React, {FC} from 'react';
import {PostType} from "../../../../Post/Post-List/core/_model";

type Props = {
    ispayment: PostType
}
const PagePublishStatus : FC<Props> = ({ispayment}) => {
    return(
        <>
            {ispayment == PostType.Publish && ( <div className='badge badge-success badge-light fw-bold'>منتشر شده</div>)}
            {ispayment == PostType.Draft && (<div className='badge badge-warning badge-light fw-bold'>پیسو نویس</div>)}
            {ispayment == PostType.PendingForAccept && (<div className='badge badge-info badge-light fw-bold'>در انتظار </div>)}
        </>
    )
};

export default PagePublishStatus;